import { render, staticRenderFns } from "./EditStaff.vue?vue&type=template&id=20254de6&scoped=true"
import script from "./EditStaff.vue?vue&type=script&lang=js"
export * from "./EditStaff.vue?vue&type=script&lang=js"
import style0 from "./EditStaff.vue?vue&type=style&index=0&id=20254de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20254de6",
  null
  
)

export default component.exports